/* @flow */

import { Store } from 'redux';

function start(store: Store): void {
  store.subscribe(() => {
    let state = store.getState();
    let action = state.get('_action');
    console.trace('action:', action.type, action, state);
  });
}

export { start };
